import { consoleRolesUrl } from "@/lib/platform-signin";
import { useOrganization } from "@/lib/organization";
import type { CultivationCapability } from "@/lib/api";
import { capabilityResource } from "./cultivation-capabilities";

export function CultivationCapabilityNotice({
  capability,
  action,
}: {
  capability: CultivationCapability;
  action: string;
}) {
  const { scope } = useOrganization();
  const rolesUrl = scope ? consoleRolesUrl(scope.organization_id) : null;
  return (
    <p role="alert" className="rounded-xl border border-[var(--warning)] p-3 text-sm text-[var(--muted-foreground)]">
      To {action}, your role needs <code className="font-mono text-[var(--foreground)]">{capabilityResource(capability)}</code>.
      {" "}Ask an organization owner to grant it in{" "}
      {rolesUrl ? (
        <a className="text-[var(--action)] underline-offset-4 hover:underline" href={rolesUrl}>
          Console roles
        </a>
      ) : (
        "Console roles"
      )}
      . The server enforces this permission; the UI gate is not the security boundary.
    </p>
  );
}
